import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { AjaxService } from '../services/ajax.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

interface Score {
  value: number;
  status?: string;
  color?: string;
}

interface Measure {
  name: string;
  short: string;
  overall: Score;
  student: Score;
  parent: Score;
  teacher: Score;
}

@Component({
  selector: 'app-survey-data',
  templateUrl: './survey-data.component.html',
  styleUrls: ['./survey-data.component.scss'],
})
export class SurveyDataComponent implements OnInit {

  measures: Measure[] = [];
  schoolId: any;
  academicYearId: any;
  rawDataLink: string | null = null;

  userSubscription: Subscription[] = [];
  counts: Record<string, any> = {}

  constructor(
    private _userService: UserService,
    private _ajaxService: AjaxService,
    private _router: Router
  ) {}

  ngOnInit(): void {

    this.userSubscription.push(
      this._userService.getSchoolId().subscribe(async value => {

        if (value != null) {

          this.schoolId = value;
          this.academicYearId = this._userService.getAcademicYearId().value;

          await this.getSurveyData();

        } else {
          this._router.navigate(['/dashboard']);
        }

      })
    );

  }


  async getSurveyData() {

    try {

      const response: any = await this._ajaxService.get(
        `survey-data/${this.academicYearId}/${this.schoolId}`
      );

      if (!response?.data) return;

      this.rawDataLink = response.data.rawDataResponse;

      const measures = response.data.measures;

      this.measures = measures.map((m: any) => {

        const measure: Measure = {
          name: m.name,
          short: m.short,
          overall: { value: m.overall },
          student: { value: m.student },
          parent: { value: m.parent },
          teacher: { value: m.teacher }
        };

        this.applyStatus(measure.overall);
        this.applyStatus(measure.student);
        this.applyStatus(measure.parent);
        this.applyStatus(measure.teacher);

        return measure;

      });

      this.counts = response.data.counts;

    } catch (error) {
      console.error("Survey API error", error);
    }

  }


  applyStatus(score: Score) {

    const value = score.value;

    if (value >= 30) {
      score.status = 'Positive';
      score.color = '#6aa84f';
    }
    else if ((value >= 10 && value <= 30)) {
      score.status = 'Leans Positive';
      score.color = '#b6d7a8';
    }
    else if (value >= -9.99 && value <= 9.99) {
      score.status = 'Neutral';
      score.color = '#ffe599';
    }
    else if (value >= -29 && value <= -10) {
      score.status = 'Leans Negative';
      score.color = '#ea9999';
    }
    else {
      score.status = 'Negative';
      score.color = '#e06666';
    }

  }


  getWidth(score: number): number {

    if (!score) return 0;

    const min = -100;
    const max = 100;

    const normalized = ((score - min) / (max - min)) * 100;

    return Math.max(0, Math.min(normalized, 100));

  }

}